module.exports = __webpack_public_path__ + "img/2.c65795c4.jpg";